<wbo-edit-page [title]="model.data.name" #editPage [formGroup]="editPage.formGroup">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.discount.edit.formation.discountDetails', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name"
                                                   [(ngModel)]="model.data.name"></wbo-text-edit-control>
                            <wbo-entity-discontinued-edit-control
                                formControlName="discontinued"
                                [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-single-select-edit-control formControlName="discType" [(ngModel)]="model.data.discType"
                                                            (valueChange)="updateValueAndValidity(['modifier.value'])"
                                                            [label]="'wbo.discount.edit.field.modifier.type.label'"
                                                            [placeholder]="'wbo.discount.edit.field.modifier.type.placeholder'"
                                                            [allowClearSelectionOption]="false">
                                <wbo-select-options>
                                    <wbo-select-option [value]="DiscountType.FIXED_DISCOUNT"
                                                       label="wbo.discount.edit.option.discount.fixedDiscount">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="DiscountType.PERCENT_DISCOUNT"
                                                       label="wbo.discount.edit.option.discount.percentDiscount">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="DiscountType.OPEN_FIXED_DISCOUNT"
                                                       label="wbo.discount.edit.option.discount.openFixedDiscount">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="DiscountType.OPEN_PERCENT_DISCOUNT"
                                                       label="wbo.discount.edit.option.discount.openPercentDiscount">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                            <fui-field formGroupName="modifier">
                                <wbo-numeric-edit-control formControlName="value"
                                                          [(ngModel)]="model.data.modifier.value"
                                                          [decimals]="2" [notation]="getMarkupNotation() | translate"
                                                          [overrideRequired]="model.data.discType === DiscountType.FIXED_DISCOUNT || model.data.discType === DiscountType.PERCENT_DISCOUNT"
                                                          [readonly]="model.data.discType === DiscountType.OPEN_FIXED_DISCOUNT || model.data.discType === DiscountType.OPEN_PERCENT_DISCOUNT"></wbo-numeric-edit-control>
                            </fui-field>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="maxDiscEnabled"
                                                       [(ngModel)]="model.data.maxDiscEnabled"
                                                       (valueChange)="updateValueAndValidity(['maxDiscValue', 'minPriceAftDiscValue'])"></wbo-checkbox-edit-control>
                            <wbo-currency-edit-control formControlName="maxDiscValue"
                                                       [(ngModel)]="model.data.maxDiscValue"
                                                       [overrideRequired]="model.data.maxDiscEnabled"
                                                       [readonly]="!model.data.maxDiscEnabled"></wbo-currency-edit-control>

                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="minPriceAftDiscEnabled"
                                                       [(ngModel)]="model.data.minPriceAftDiscEnabled"
                                                       (valueChange)="updateValueAndValidity(['maxDiscValue', 'minPriceAftDiscValue'])"></wbo-checkbox-edit-control>
                            <wbo-currency-edit-control formControlName="minPriceAftDiscValue"
                                                       [(ngModel)]="model.data.minPriceAftDiscValue"
                                                       [overrideRequired]="model.data.minPriceAftDiscEnabled"
                                                       [readonly]="!model.data.minPriceAftDiscEnabled"></wbo-currency-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="minSaleAmtBefDiscEnabled"
                                                       [(ngModel)]="model.data.minSaleAmtBefDiscEnabled"
                                                       (valueChange)="updateValueAndValidity(['minSaleAmount'])"></wbo-checkbox-edit-control>
                            <wbo-currency-edit-control formControlName="minSaleAmount"
                                                       [(ngModel)]="model.data.minSaleAmount"
                                                       [overrideRequired]="model.data.minSaleAmtBefDiscEnabled"
                                                       [readonly]="!model.data.minSaleAmtBefDiscEnabled"></wbo-currency-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column formGroupName="modifier">
                        <wbo-checkbox-edit-control formControlName="roundingApplied"
                                                   [(ngModel)]="model.data.modifier.roundingApplied"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row [label]="'wbo.discount.edit.field-set.application'">
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="requiresReason"
                                                       [(ngModel)]="model.data.requiresReason"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control formControlName="requiresManagementPrivilege"
                                                       [(ngModel)]="model.data.requiresManagementPrivilege"></wbo-checkbox-edit-control>
                        </fui-tandem-field>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="includeCompositeComponents"
                                                       [(ngModel)]="model.data.includeCompositeComponents"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control formControlName="ignoreReducedPriceItems"
                                                       [(ngModel)]="model.data.ignoreReducedPriceItems"></wbo-checkbox-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row [label]="'wbo.discount.edit.field-set.usage'">
                <fui-two-columns>
                    <fui-column formGroupName="usage">
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="manualToItem"
                                                       [(ngModel)]="model.data.usage.manualToItem"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control formControlName="manualToSale"
                                                       [(ngModel)]="model.data.usage.manualToSale"></wbo-checkbox-edit-control>
                        </fui-tandem-field>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="membershipType"
                                                       [(ngModel)]="model.data.usage.membershipType"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control formControlName="member"
                                                       [(ngModel)]="model.data.usage.member"></wbo-checkbox-edit-control>
                        </fui-tandem-field>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="account"
                                                       [(ngModel)]="model.data.usage.account"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control formControlName="entitlement"
                                                       [(ngModel)]="model.data.usage.entitlement"></wbo-checkbox-edit-control>
                        </fui-tandem-field>

                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="table"
                                                       [(ngModel)]="model.data.usage.table"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control formControlName="barcode"
                                                       [(ngModel)]="model.data.usage.barcode"></wbo-checkbox-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row [label]="'wbo.discount.edit.field-set.other'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description"
                                                   [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="barcode"
                                               [(ngModel)]="model.data.barcode"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.discount.edit.formation.discountFilter', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column formGroupName="category">
                        <wbo-category-single-select-edit-control formControlName="categoryId"
                                                                 [(ngModel)]="model.data.category.categoryId"
                                                                 [objectValue]="model.data.category">
                        </wbo-category-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.sellables" [editable]="false" [removable]="true"
                                   [entityPath]="'sellables'" [title]="'wbo.discount.edit.field-set.sellables'">
                        <wbo-sellable-edit-link-column field="name"
                                                       [editMode]="EditMode.VIEW"></wbo-sellable-edit-link-column>
                        <wbo-column field="plu"></wbo-column>
                        <wbo-currency-column field="price"></wbo-currency-column>
                        <wbo-edit-grid-add-row [identifierField]="'sellableId'">
                            <wbo-edit-grid-add-row-quick-add>
                                <wbo-sellable-single-select-edit-control></wbo-sellable-single-select-edit-control>
                            </wbo-edit-grid-add-row-quick-add>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-search
                                    [title]="'wbo.discount.edit.grid-add.products.addProductLines'"
                                    [searchPath]="'product-line-search'"></wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-search
                                    [title]="'wbo.discount.edit.grid-add.products.addCompositeProducts'"
                                    [searchPath]="'composite-product-search'"></wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-new-entity
                                    [title]="'wbo.discount.edit.grid-add.products.newProductLine'"
                                    [editPath]="'product-line'"></wbo-edit-grid-add-row-new-entity>
                                <wbo-edit-grid-add-row-new-entity
                                    [title]="'wbo.discount.edit.grid-add.products.newCompositeProduct'"
                                    [editPath]="'composite-product'"></wbo-edit-grid-add-row-new-entity>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <ng-container
        *ngIf="(Config.BACKOFFICE_PRICING_MAINTAIN_SURCHARGE_DISCOUNT_INTERACTION_VIA | stringConfig) !== 'surcharge'">
        <fui-formation-group-template
            *formationGroup="{title: 'wbo.discount.edit.formation.surchargeInteractions', formControlNames: ''}">
            <fui-rows>
                <fui-row>
                    <fui-column>
                        <wbo-edit-grid [data]="model.data.surchargeInteractions" [editable]="true" [removable]="true"
                                       [entityPath]="'surchargeInteractions'">
                            <wbo-edit-link-column field="surcharge.name" componentPath="surcharge"
                                                  [editPath]="'surcharge'"
                                                  [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                            <wbo-translated-column field="surcharge.modifier.displayType"
                                                   prefix="wbo.pricing.markup-type"></wbo-translated-column>
                            <wbo-numeric-column field="surcharge.modifier.value"></wbo-numeric-column>
                            <wbo-checkbox-column field="surchargeUndiscountedPrice"
                                                 [editable]="true"></wbo-checkbox-column>
                            <wbo-edit-grid-add-row [identifierField]="'surchargeId'" componentPath="surcharge" #addRow
                                                   [customAddQuickSelect]="true">
                                <wbo-edit-grid-add-row-quick-add (onSelect)="addRow.addRow($event, true)">
                                    <wbo-surcharge-single-select-edit-control></wbo-surcharge-single-select-edit-control>
                                </wbo-edit-grid-add-row-quick-add>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-search
                                        [searchPath]="'surcharge'"></wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-new-entity
                                        [editPath]="'surcharge-search'"></wbo-edit-grid-add-row-new-entity>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-row>
            </fui-rows>
        </fui-formation-group-template>
    </ng-container>
</wbo-edit-page>
